module.exports = __webpack_public_path__ + "static/media/idCardSuyo.7c4f2078.png";